import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import Banner3 from "../../assets/images/dasboard/banner3.png";
import gymstreak2 from "../../assets/images/gym/gym-streak-2.png";
import gymstreak6 from "../../assets/images/gym/gym-streak-6.png";
import Drawer from "react-modern-drawer";
import GymView from "../Sidebar/GymView";
import { useDispatch, useSelector } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import { GET_GOOD_READ_ENDPOINT } from "../../config/ApisCollection";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const GoodReadTopic = () => {
  let history = useNavigate();
  const { type, category } = useParams();
  const [isDrawerPopupOpen, setDrawerPopupOpen] = useState(false);
  const [workoutChoosedData, setWorkoutChoosedData] = useState(null);
  const [goodread_data, set_goodread_data] = useState(null);
  const dispatch = useDispatch();
  const accessToken = secureLocalStorage.getItem("accessToken");

  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
    await dispatch(setIsDrawerActive(true));
  };
  const getGoodReadData = async () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
    const formattedTime = currentDate.toTimeString().split(" ")[0]; // Format time as HH:MM:SS
    const post_header = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    try {
      await axios
        .post(`${GET_GOOD_READ_ENDPOINT}/${type}/${category}`, {}, post_header)
        .then((response) => {
          set_goodread_data(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getGoodReadData();
  }, []);

  return (
    <>
      <MainBg>
        {goodread_data !== null ? (
          <div className="grid sm:grid-cols-1  grid-cols-1 sm:gap-20 py-20 mb-20">
            <div className="col-span-2 md:px-10 px-2 sm:border-r-2 border-none">
              {/* <div className="">
                <input
                  type="text"
                  className="w-full border-2 border-gray-350 p-2 rounded-lg"
                  placeholder="↻ Search workouts..."
                />
              </div> */}
              <div>
                {Object.entries(goodread_data?.date).length &&
                  Object.entries(goodread_data?.date).length !== 0 &&
                  Object.entries(goodread_data?.date).map((cl_row, index) =>
                    index == 0 ? (
                      <span key={index}>
                        <div className="mt-10">
                          <h1 className="font-bold text-capitalize">
                            {typeof cl_row[1] === "string" ? cl_row[1] : ""}
                          </h1>
                        </div>
                        <div className="mt-2 grid xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-5">
                          {goodread_data?.date?.searchedlist.map(
                            (wl_row, index) =>
                              wl_row.category === wl_row.category ? (
                                <div
                                  className="melasbox hover:bg-[#ffe1cb] cursor-pointer"
                                  onClick={() => {
                                    history("/good-read/article/" + wl_row.id);
                                  }}
                                  key={index}
                                >
                                  <div>
                                    <img
                                      loading="lazy"
                                      src={wl_row.blogimage}
                                      alt="meals1"
                                      className="mealsimg h-[135px]"
                                      width={145}
                                      height={135}
                                    />
                                  </div>
                                  <div className="melalin">
                                    <div className="modesutit text-capitalize">
                                      {wl_row.contentType}
                                    </div>
                                    <div className="tabetsbol text-capitalize">
                                      {wl_row.title.substring(0, 40)}
                                    </div>
                                    <hr />
                                    <div className="fastiweekboxtit">
                                      {wl_row.subCategory}{" "}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <>Not found...</>
                              )
                          )}
                        </div>
                      </span>
                    ) : (
                      <></>
                    )
                  )}
              </div>
              <div></div>
            </div>
            <div className="flex sm:flex-row flex-col justify-center hidden">
              <div>
                <div
                  className="cardbox sm:w-3/4 w-full bg-cover bg-center px-0"
                  style={{ backgroundImage: "url('/images/bannerActive.png')" }}
                >
                  <div className="mode1">
                    <img
                      className="watchImg"
                      alt="watchImg"
                      src={goodread_data?.explore?.backgrounding}
                    />
                    <div>
                      <p className="cardboxtitle text-base">
                        {goodread_data?.explore?.title}
                      </p>
                      <p className="text-xs">
                        {goodread_data?.explore?.tagline}
                      </p>
                      <button
                        className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                        onClick={() => {
                          handleChangeSidebar(314);
                        }}
                      >
                        {goodread_data?.explore?.buttonNmae}
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className="cardbox sm:w-3/4 w-full bg-cover bg-center px-0"
                  style={{ backgroundImage: "url('/images/bannerActive.png')" }}
                >
                  <div className="mode1">
                    <img
                      className="watchImg"
                      alt="watchImg"
                      src={goodread_data?.explore?.backgrounding}
                    />
                    <div>
                      <p className="cardboxtitle text-base">
                        {goodread_data?.browsetopic?.title}
                      </p>
                      <p className="text-xs">
                        {goodread_data?.browsetopic?.tagline}
                      </p>
                      <button
                        className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                        onClick={() => {
                          handleChangeSidebar(314);
                        }}
                      >
                        {goodread_data?.browsetopic?.buttonNmae}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </MainBg>
    </>
  );
};
export default React.memo(GoodReadTopic);
